import { Component } from '@angular/core'

@Component({
  selector: 'se-po-household-invite-docs',
  templateUrl: './household-invite-docs.component.html',
  styleUrls: ['./household-invite-docs.component.scss'],
  standalone: false,
})
export class HouseholdGuardianInviteDocsComponent {
}
